import {
  // RECEIVE_TRADE_ACCOUNT_LIST,
  // RECEIVE_TRADE_ACCOUNT_ORDERID,
  // RECEIVE_TRADE_ACCOUNT_RECORDS,
  RECEIVE_USERINFO,
  RECEIVE_ACCOUNTINFO,
  RECEIVE_REJECT_RECORDS,
  RECEIVE_LANGUAGE,
  RECEIVE_ACCOUNT_BALANCE
} from './mutation-type'

import {
  reqCreateAccountRecords,
  reqApplyTradeRecords,
  // reqRejectRecords,
  reqImgUrl
  // reqAccountBalance
  // reqSysconfig,
} from '../api/other-account/index.js'
import api from '../api/api'
import api1 from '@/api/v2/trade'

import {
  reqPMCode,
  reqVerifyCode,
  reqResetPwd,
  reqResetSuccess,
  reqAgreementStatus,
  reqUpdateAgreementStatus
} from '../api/reset-pm-password/index.js'

export default {
  selectLang ({ commit }, lang) {
    commit(RECEIVE_LANGUAGE, { lang })
  },
  getImage ({ commit, state }, imgKey) {
    // sessionStorage.setItem('imgKey',imgKey)
    return reqImgUrl(imgKey)
  },
  async getRejectList ({ commit, state }, option) {
    // const result = await reqRejectRecords(option)
    // if (result.code === 200) {
    //   const rejectRecords = result.data[0]
    //   commit(RECEIVE_REJECT_RECORDS, { rejectRecords })
    // }
    console.log(option)
    commit(RECEIVE_REJECT_RECORDS, { option })
  },
  // async getTradeAccountList ({ commit, state }) {
  //   const { accountNumber } = state.user.profile.custom
  //   return reqTradeAccountList(accountNumber)
  // },
  async getApplyTradeRecords ({ commit, state }, options) {
    return reqApplyTradeRecords(options)
  },
  async createAccount ({ commit, state }, option) {
    try {
      const result = await reqCreateAccountRecords(option)
      if (result.code === 200) {
        return result.data
      }
    } catch (error) {
      throw error
    }
  },
  async getUserInfoByidpUserId ({ commit, state }, data) {
    commit(RECEIVE_USERINFO, data)
  },
  async getAcountType ({ commit, state }, option) {
    const result = await api.getAcountType(option)
    if (result.code === 200) {
      commit(RECEIVE_ACCOUNTINFO, result.data)
      // return result.data
    }
  },
  async getTradeAccountListByIdpUserId ({ commit, state }, option) {
    const result = await api.getTradeAccountListByIdpUserId(option)
    if (result.code === 200) {
      return result.data
    }
  },
  async getPMCode ({ commit, state }, options) {
    const result = await reqPMCode(options)
    return result
  },
  async verifyCode ({ commit, state }, options) {
    return reqVerifyCode(options).then(result => {
      return result
    }).catch(err => {
      throw err
    })
    // const result = await reqVerifyCode(options)
    // return result
  },
  async resetPwd ({ commit, state }, options) {
    return reqResetPwd(options).then(result => result).catch(err => {
      throw err
    })
  },
  async resetSuccess ({ commit, state }, options) {
    return reqResetSuccess(options)
  },
  async getAgreementStatus ({ commit, state }, options) {
    return reqAgreementStatus(options)
  },
  async updateAgreementStatus ({ commit, state }, options) {
    return reqUpdateAgreementStatus(options)
  },
  setAccountOpeningAgreement ({ commit, state }, accountOpeningAgreement) {
    commit('setAccountOpeningAgreement', accountOpeningAgreement)
  },
  async getSysconfig ({ commit, state }, val) {
    commit('setBullion', val)
  },
  async getAccountBalance ({ commit, state }, options) {
      const result = await api1.getAccountInfo()
      if (result.code === 200) {
        commit(RECEIVE_ACCOUNT_BALANCE, result.data)
      }
  },
  setSubBankAccounts ({ commit, state }, subBankAccounts) {
    commit('setSubBankAccounts', subBankAccounts)
  }
}
